export { default as AssetsPicker } from './assets-picker';
